import axios from 'axios';
const API_URL = import.meta.env.VITE_BACKEND_URL;

export const workflowAIApi = {
  // Run store analysis
  analyzeStore: async () => {
    const response = await axios.post(`${API_URL}/api/workflow/analyze`);
    return response.data;
  },

  // Get existing analysis
  getAnalysis: async () => {
    const response = await axios.get(`${API_URL}/api/workflow/analysis`);
    return response.data;
  },

  // Error handling wrapper
  handleRequest: async (request) => {
    try {
      return await request();
    } catch (error) {
      if (error.response) {
        throw new Error(error.response.data.message || 'An error occurred with the WorkflowAI service');
      }
      throw error;
    }
  }
};

// Wrap all methods with error handling
Object.keys(workflowAIApi).forEach(key => {
  if (typeof workflowAIApi[key] === 'function' && key !== 'handleRequest') {
    const originalMethod = workflowAIApi[key];
    workflowAIApi[key] = (...args) => workflowAIApi.handleRequest(() => originalMethod(...args));
  }
}); 